// src/GlobalStyles.jsx
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  }

  /* Custom scrollbar for DiamondBank */
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #d2d8e1;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #470a91 0%, #35076d 100%);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #5e1bb5 0%, #470a91 100%);
  }

  /* Selection color */
  ::selection {
    background: #470a91;
    color: white;
  }

  ::-moz-selection {
    background: #470a91;
    color: white;
  }

  /* Smooth scrolling */
  html {
    scroll-behavior: smooth;
  }

  /* Animation keyframes */
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
  }

  /* Utility classes */
  .fade-in-up {
    animation: fadeInUp 0.6s ease-out;
  }

  .fade-in {
    animation: fadeIn 0.4s ease-out;
  }

  /* Gradient text for DiamondBank branding */
  .gradient-text {
    background: linear-gradient(135deg, #470a91 0%, #5e1bb5 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  /* Responsive container */
  .container {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 20px;
  }

  @media (max-width: 768px) {
    .container {
      padding: 0 16px;
    }
  }
`;

export default GlobalStyles;